import React, {useRef} from 'react';
import {useDispatch, useSelector} from 'react-redux';

import {cancelPasswordReset, submitForgottenPasswordCode} from 'modules/authentication/actions';
import {invalidResetCodeSelector} from 'modules/authentication/selectors';

import CancelAndContinueButtons from 'components/Authentication/Controls/CancelAndContinueButtons';
import InputField from 'components/Authentication/Controls/InputField';
import AuthenticationContainer from './AuthenticationContainer';

export default function ForgottenPasswordCode() {

    const dispatch = useDispatch();
    const inputRef = useRef(null);
    const invalidCode = useSelector(invalidResetCodeSelector);

    const continueAction = () => {
        dispatch(submitForgottenPasswordCode(inputRef.current.value));
    };

    const cancelAction = () => {
        dispatch(cancelPasswordReset());
    };

    return <AuthenticationContainer title="Forgotten Password">
        <p>
            If an account associated with this email exists, a verification code
            has been sent. Please check your inbox and enter the code into the
            field below to proceed.
        </p>
        <p>
            If you do not receive the email, check your spam folder or cancel
            and try again.
        </p>
        {invalidCode && <p style={{ color: 'red', fontWeight: 'bold' }}>Invalid code. Please try again.</p>}
        <InputField label="Enter Code" type="text" required={true} inputRef={inputRef}/>
        <CancelAndContinueButtons cancelAction={cancelAction} continueAction={continueAction}/>
    </AuthenticationContainer>;

}